import React, { useEffect, useState } from 'react';
import Modal from '../../../../../../Components/Modal/Modal';
import { NCZIEntry } from '../../../../Interfaces/ncziTypes';
import EHREntryModalContent from './EHREntryModalContent';
import { useTreatmentContext } from '../../../../../../Services/TreatmentContext';
import { Size } from '../../../../../../Enums/Size.enum';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	entry: NCZIEntry;
	patientIdentifier: string;
}

const EHREntryModal: React.FC<Props> = props => {
	const { opened, onClose, entry, patientIdentifier } = props;
	const [entryTitle, setEntryTitle] = useState<string>(entry.name);
	const { isCase } = useTreatmentContext();

	useEffect(() => {
		for (const entryItem of entry.items) {
			if (
				entryItem.element &&
				[
					'CEN-EN13606-ENTRY.Zaznam_o_vysetreni-Zaznam_o_odbornom_vysetreni.v7/at0.34',
				].indexOf(entryItem.element.archetypeId) !== -1
			) {
				setEntryTitle(entryItem.element.value);
			}
		}
	}, []);

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(false)}
			fullScreen={false}
			wrapChat={isCase}
			size={Size.LG}>
			<Modal.Header title={entryTitle} />
			<Modal.Content>
				<EHREntryModalContent
					entry={entry}
					patientIdentifier={patientIdentifier}
					onCancel={() => onClose(true)}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default EHREntryModal;
